import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<rect width="24" height="24" rx="4" fill="#C1D0CB"/> <path d="m20.073 17.23-.117.12a3.13 3.13 0 0 1-4.494 0L12 13.8l-3.462 3.55a3.133 3.133 0 0 1-4.495 0l-.116-.12c-1.236-1.268-1.236-3.341 0-4.609L9.753 6.65a3.134 3.134 0 0 1 4.494 0l.117.12 5.709 5.851c1.236 1.268 1.236 3.341 0 4.609Z" fill="#193446"/>' }
  })
);